<div
  data-qa-id="popup-background"
  class="root"
  [class.-top-position]="topPosition"
  [@visibility]="state"
  (@visibility.done)="onAnimationDone()"
  (click)="close()"
>
  <div
    class="popup"
    [class.-mobile]="isMobile"
    [class.-has-footer]="hasFooter"
    [style.margin-top.px]="marginTop"
    (click)="$event.stopPropagation()"
  >
    <div
      *ngIf="hasHeader"
      class="popup-header"
      [class.-with-close-icon]="(!hasFooter && closeable) || forceCloseIcon"
    >
      <sky-ui-icon
        *ngIf="(!hasFooter && closeable) || forceCloseIcon"
        class="popup-cross-icon"
        size="m"
        [svgContent]="closeIcon"
        (click)="close()"
      ></sky-ui-icon>

      <ng-content select="[skyUiPopupTitle]"></ng-content>
    </div>

    <div *ngIf="hasScroll" class="popup-body -has-scroll" skyUiNativeScroll #body>
      <ng-container *ngTemplateOutlet="popupBody"></ng-container>
    </div>
    <div *ngIf="!hasScroll" class="popup-body" #body>
      <ng-container *ngTemplateOutlet="popupBody"></ng-container>
    </div>

    <ng-template #popupBody>
      <ng-content select="[skyUiPopupBody]"></ng-content>
    </ng-template>

    <div *ngIf="hasFooter" class="popup-footer" [class.-centred]="centerFooter">
      <div class="popup-footer-item">
        <ng-content select="[skyUiPopupFooterCustomContent]"></ng-content>
      </div>

      <div class="popup-footer-item">
        <ng-content select="[skyUiPopupAcceptButton]"></ng-content>
      </div>

      <div class="popup-footer-item">
        <ng-content select="[skyUiPopupDeclineButton]"></ng-content>
      </div>
    </div>
  </div>
</div>
